<ng-container *ngIf="request">
  <app-breadcrumb [secondCrumb]="request.jobName"></app-breadcrumb>

  <!-- Small and medium viewport -->
  <div class="d-block d-lg-none" *ngIf="request && request.id">
    <div class="d-block d-lg-none m-3 mx-md-5 mt-md-3 accordion" id="accordion">
      <!-- REQUEST -->
      <div class="accordion-item cursor-pointer">
        <div class="accordion-header justify-content-between bg-light" id="request">
          <div class="p-3 pb-2">
            <h3 class="mb-0 text-primary cursor-pointer active default-font-size">
              <mobile-status-actions class="float-end"></mobile-status-actions>
              <div data-bs-toggle="collapse" data-bs-target="#request-panel" aria-expanded="false"
                aria-controls="request-panel">
                <div class="cursor-pointer">{{request.jobName}}</div>
                <div class="d-block mt-1">
                  <pillbadge-status-display [data]="statusBadge" [status]="statusIndicator" [iconTag]="''"
                    [disable]="false"></pillbadge-status-display>
                </div>
              </div>
            </h3>
          </div>
        </div>
        <div id="request-panel" class="accordion-collapse collapse show indent" aria-labelledby="request"
          data-bs-parent="#accordion">
          <div class="accordion-body p-0 h-100">
            <app-request-status-info></app-request-status-info>
          </div>
        </div>
      </div>
      <!-- SENDGROUPS - accordion item with header per sendgroup -->
      <mobile-request-status-sendgroup-list></mobile-request-status-sendgroup-list>
      <!-- DOCUMENTS -->
      <div class="accordion-item cursor-pointer">
        <div class="accordion-header justify-content-between bg-light" id="documents">
          <div class="p-3" data-bs-toggle="collapse" data-bs-target="#documents-panel" aria-expanded="false"
            aria-controls="documents-panel">
            <h3 class="mb-0 text-primary cursor-pointer active default-font-size">
              <span class="cursor-pointer" translate="Request.Status.Documents"></span>
            </h3>
          </div>
        </div>
        <div id="documents-panel" class="accordion-collapse collapse indent" aria-labelledby="documents"
          data-bs-parent="#accordion">
          <div class="accordion-body p-0 h-100">
            <app-request-status-documents-list></app-request-status-documents-list>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- large viewport -->
  <div class="d-none d-lg-block">
    <div
      class="d-none d-lg-block container-fuid mx-2 mx-sm-2 mx-md-2 mx-lg-5 mx-xl-5 mx-xxl-5 default-boxshadow mt-2 mt-4 bg-white default-boxrounded p-0">

      <app-requeststatustitle></app-requeststatustitle>
      <div class="status-container">

        <div class="break-words ps-4 pe-4" *ngIf="displayRejectionHeader">
          <div class="alert alert-danger p-1 mt-0 white-space" role="alert">
            {{request.rejectionUserName}} : {{request.rejectionReason}}
          </div>
        </div>

        <div class="break-words ps-4 pe-4" *ngIf="displayWithdrawnHeader">
          <div class="alert alert-danger p-1 mt-0 white-space" role="alert">
            {{request.withdrawnUserName}} : {{request.withdrawnReason}}
          </div>
        </div>

        <div class="side-by-side-height-by-height-container float-start w-100 cols-12 bg-white default-boxrounded">
          <div class="col-4 ps-4 pt-1 pe-2 pb-4">
            <div class="h-b-h">
              <app-request-status-info></app-request-status-info>
            </div>
          </div>
          <div class="col-8 pt-1 p-4">
            <div class="h-b-h">
              <desktop-status-log></desktop-status-log>
            </div>
          </div>
        </div>

        <div class="bg-white default-boxrounded">
          <div class="p-4 p-1">
            <desktop-request-status-sendgroup-list></desktop-request-status-sendgroup-list>
          </div>
        </div>

        <div class="bg-white default-boxrounded">
          <div class="ps-4 pt-0 pe-4 pb-4 p-1">
            <app-request-status-documents-list></app-request-status-documents-list>
          </div>
        </div>
      </div>
    </div>

  </div>
</ng-container>